import { useEffect, useState } from 'react';
import TextInput from '../TextInput';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { setFlowQuery, useFlowQuery } from '../../lib/Queries';
import StepEdit, { DEFAULT_ACTION } from './StepEdit.jsx';
import FlowStep from './FlowStep.jsx';
import Modal from '../Modal';
import { TriggerTypesToHuman, TriggerOrder } from '../../lib/Flows.js';
import { ucfirst } from '../../lib/Utils.js';
import Loading from '../Loading';
import ErrorMessage from '~/components/ErrorMessage';

const FlowBuilder = ({ flowableId, flowableType, className }) => {
    const [showAddStep, setShowAddStep] = useState(false);

    const [newStepData, setNewStepData] = useState({
        offset: null,
        action: DEFAULT_ACTION,
    });

    const { data, isLoading, isError } = useFlowQuery(flowableType, flowableId);
    console.log('flow url = ', `/flows/${flowableType}/${flowableId}/0`)
    const { save, isSaving: isAddingStep } = useBusinessPostApi(
        `/flows/${flowableType}/${flowableId}/0`,
    );

    const steps = data?.steps || [];
    const contextSchema = data?.schema || [];
    const triggerTypes = data?.triggerTypes || [];

    const stepsByTrigger = Object.groupBy(
        steps.filter(s => triggerTypes.indexOf(s.trigger) > -1),
        step => step.trigger,
    );

    async function submitAddStep() {
        await save({
            ...newStepData,
        }).then(result => {
            setFlowQuery(flowableType, flowableId, result);
            setShowAddStep(false);
        });
    }

    return (
        <div className={className || 'mt-10'}>
            {Object.keys(stepsByTrigger).length === 0 && !isLoading && (
                <div>
                    {isError && (
                        <ErrorMessage>
                            Failed to load the automations, please refresh and
                            try again.
                        </ErrorMessage>
                    )}
                    {!isError && (
                        <div className="text-gray-500 my-4">
                            There are no emails that will be sent or other
                            actions that will be taken.
                        </div>
                    )}
                </div>
            )}
            {isLoading && <Loading className="mb-4" />}

            {Object.keys(stepsByTrigger)
                .sort((a, b) => TriggerOrder[a] - TriggerOrder[b])
                .map(trigger => (
                    <div className="mb-6" key={trigger}>
                        <div className="panel-label">
                            {TriggerTypesToHuman[trigger]}
                        </div>
                        <div className="group">
                            {stepsByTrigger[trigger].map(step => (
                                <FlowStep
                                    key={step.id}
                                    step={step}
                                    flowableType={flowableType}
                                    flowableId={flowableId}
                                    schema={contextSchema}
                                    triggerTypes={triggerTypes}
                                />
                            ))}
                            <div className="overflow-hidden max-h-0 opacity-0 transition-all duration-500 ease-in-out group-hover:max-h-40 group-hover:opacity-100">
                                <button
                                    className="btn-light-pill"
                                    onClick={() => {
                                        setNewStepData({
                                            offset: 0,
                                            action: DEFAULT_ACTION,
                                            trigger: trigger,
                                        });
                                        setShowAddStep(true);
                                    }}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                ))}

            <Modal
                isOpen={showAddStep}
                onClose={() => {
                    if (
                        !!newStepData &&
                        !confirm(
                            'You have unsaved changes. Are you sure you want to close?',
                        )
                    ) {
                        return;
                    }

                    setShowAddStep(false);
                }}
                widthClass="sm:max-w-[650px]"
            >
                <StepEdit
                    data={newStepData}
                    setData={setNewStepData}
                    doSubmit={submitAddStep}
                    isSubmitting={isAddingStep}
                    schema={contextSchema}
                    triggerTypes={triggerTypes}
                />
            </Modal>

            {Object.keys(stepsByTrigger).length < 4 && (
                <div className="pb-6">
                    <button
                        className="btn-pill"
                        onClick={() => {
                            setNewStepData({
                                offset: 0,
                                action: DEFAULT_ACTION,
                            });
                            setShowAddStep(true);
                        }}
                    >
                        Add Action
                    </button>
                </div>
            )}
        </div>
    );
};

export default FlowBuilder;
